// extracted by mini-css-extract-plugin
export default {"wrapper":"IconCell_wrapper__UQgYv","text":"IconCell_text__ljcCU"};